
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { 
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

interface SettingsBreadcrumbProps {
  activeTab: string;
}

const SettingsBreadcrumb = ({ activeTab }: SettingsBreadcrumbProps) => {
  // Get human-readable tab name for breadcrumb
  const getTabName = (tab: string) => {
    switch(tab) {
      case 'devices': return 'Devices';
      case 'devicegroups': return 'Device Groups';
      case 'protocols': return 'Protocol Handlers';
      case 'account': return 'Account';
      case 'datasources': return 'Data Sources';
      case 'users': return 'Users';
      case 'notifications': return 'Notifications';
      case 'system': return 'System';
      case 'security': return 'Security & Access';
      case 'ai': return 'AI & LLM';
      case 'billing': return 'Tariff & Billing';
      case 'sustainability': return 'Sustainability';
      case 'webhooks': return 'Webhooks & APIs';
      default: return 'Settings';
    }
  };

  return (
    <div className="flex flex-col space-y-4">
      <Button variant="outline" asChild className="gap-2 w-fit">
        <Link to="/">
          <ArrowLeft className="h-4 w-4" />
          Back to Dashboard
        </Link>
      </Button>
      
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink href="/" asChild>
              <Link to="/">Dashboard</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink href="/settings" asChild>
              <Link to="/settings">Settings</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>{getTabName(activeTab)}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};

export default SettingsBreadcrumb;
